module.exports = __webpack_public_path__ + "img/map4.649ab370.png";